import {Model} from '@/models/Model'
import {DataPromotionsArray} from '@/models/Promotion'
import {Province} from '@/models/Province'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export class City extends Model {
  declare id: number | null
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  primary_district: number | null
  lat: number | null
  lng: number | null

  province: Province | null
  getResourceURL(): string {
    return Helper.setting.city.getResourceAPI
  }

}

export class DataCitiesArray extends DataArray {

  declare data: City[]
  filter: FilterCity = new FilterCity()
}


export class FilterCity {
  price_group: FilterSet = new FilterSet()
}


export class DataCity extends DataResource {

  declare data: City

}
